export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 },
];

export const initialFilter = {
  pageNumber: 1,
  pageSize: 10,
  filter: {},
};

export const statusLabel = (status) => {
  let data = {};
  switch (status) {
    case "WAITING":
      data = {
        type: "warning",
        name: "MENUNGGU PEMBAYARAN",
      };
      break;
    case "PAID":
      data = {
        type: "primary",
        name: "DIBAYAR",
      };
      break;
    case "EXPIRED":
      data = {
        type: "danger",
        name: "KADALUARSA",
      };
      break;

    default:
      data = {
        type: "dark",
        name: "MENUNGGU PEMBAYARAN",
      };
      break;
  }

  return data;
};
